/**
 * Application Constants
 * アプリケーション全体で使用する定数を一元管理
 */

// ============================================
// Route Paths (ルートパス)
// ============================================

export const ROUTES = {
  // Public Pages (公開ページ)
  HOME: '/',
  LOGIN: '/login',
  STAFF_LOGIN: '/staff-login',
  REGISTER: '/register',
  GUIDE: '/guide',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  LAW: '/law',
  POLICY: '/policy',
  COMPANY: '/company',
  VERIFY_EMAIL: '/verify-email',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',

  // Staff Pages (スタッフページ)
  STUDIO: '/studio',
  CONSOLE: '/console',
  PUBLISH_OME: '/publish-ome',
  STREAMER_MYPAGE: '/streamer-mypage',
  STAFF_SETTINGS: '/staff-settings',

  // Watch Pages (視聴ページ)
  WATCH: '/watch',
  WATCH_STREAMER: (streamerId: string) => `/watch/${streamerId}` as const,
  WATCH_BEFORE_ENTRY: (streamerId: string) => `/watch/${streamerId}/before-entry` as const,
  WATCH_LIVE_ROOM: (streamerId: string) => `/watch/${streamerId}/live-room` as const,
  WATCH_PEEK_ROOM: (streamerId: string) => `/watch/${streamerId}/peek-room` as const,

  // Other Pages (その他)
  POINTS: '/points',
  SETTINGS: '/settings',
} as const;

// Route patterns for matching (ルートパターン - マッチング用)
export const ROUTE_PATTERNS = {
  WATCH_STREAMER: '/watch/:streamerId',
  WATCH_BEFORE_ENTRY: '/watch/:streamerId/before-entry',
  WATCH_LIVE_ROOM: '/watch/:streamerId/live-room',
  WATCH_PEEK_ROOM: '/watch/:streamerId/peek-room',
} as const;

// ============================================
// Storage Keys (ストレージキー)
// ============================================

export const STORAGE_KEYS = {
  // Auth tokens
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',

  // User preferences
  LANGUAGE: 'lang',
  AGE_VERIFIED: 'age_verified',

  // Form data
  REGISTER_FORM: 'register_form_data',
} as const;

// ============================================
// External URLs (外部URL)
// ============================================

export const EXTERNAL_URLS = {
  // Age verification rejection redirect
  GOOGLE: 'https://www.google.com',
} as const;

// ============================================
// Auth-related paths (認証関連パス)
// ============================================

// Paths that skip age verification
export const AGE_VERIFICATION_SKIP_PATHS = [
  ROUTES.POLICY,
  ROUTES.TERMS,
  ROUTES.LAW,
  ROUTES.PRIVACY,
  ROUTES.COMPANY,
  ROUTES.STAFF_LOGIN,
  ROUTES.STUDIO,
  ROUTES.CONSOLE,
  ROUTES.PUBLISH_OME,
  ROUTES.STREAMER_MYPAGE,
  ROUTES.STAFF_SETTINGS,
] as const;

// Default login redirect paths by user type
export const LOGIN_PATHS = {
  VIEWER: ROUTES.LOGIN,
  STAFF: ROUTES.STAFF_LOGIN,
} as const;

// ============================================
// Viewer Presence (視聴者プレゼンス)
// ============================================

/**
 * サーバーの視聴者プレゼンスタイムアウト (ミリ秒)
 * バックエンドのVIEWER_PRESENCE_TIMEOUT_SECONDS=10と一致させる
 */
export const VIEWER_PRESENCE_TIMEOUT_MS = 10000;

/**
 * 視聴者ハートビート間隔 (ミリ秒)
 * タイムアウトの半分以下に設定して確実にプレゼンスを維持
 * Bug #17: 30秒→5秒に修正（タイムアウト10秒の半分）
 */
export const VIEWER_HEARTBEAT_INTERVAL_MS = 5000;
